export default class GalleryFormSerializer {
    static serialize(gallery) {
        return {
            id: gallery.id || null,
            name: gallery.name,
            description: gallery.description,
        };
    }

    static unserialize(gallery) {
        return {
            id: gallery.id,
            name: gallery.name,
            description: gallery.description,
        };
    }
}


// WEBPACK FOOTER //
// ./web/src/services/GalleryFormSerializer.js